import { useState, useEffect } from 'react';
import { getSupplyCoreAuthBaseUrl } from '../services/api.service';

export function useSession() {
  const [session, setSession] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  async function fetchSession() {
    const authBaseUrl = getSupplyCoreAuthBaseUrl();
    const sessionUrl = `${authBaseUrl}/auth/session`;
    try {
      const res = await fetch(sessionUrl, { credentials: 'include' });
      if (!res.ok) throw new Error(res.status);
      const { data } = await res.json();
      setSession(data);
      setIsError(false);
    } catch (err) {
      console.error('[useSession] Session fetch failed:', err.message);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchSession();
    const onVisible = () => {
      if (document.visibilityState === 'visible') fetchSession();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);

  return { session, isLoading, isError };
}
